/**
 * @class
 */
import Base from './menuView';
import Template from '../templates/advancedMenuView.html';
import ChildView from './advancedMenuItemView';

import ChildViews from '@netx/core/functionality/childViews';

export default class AdvancedMenuView extends Base {
	/** @override */
	constructor(opts = {}) {
		opts.childView = {
			viewClass: ChildView,
			target: '.advanced-menu-items',
			options: {
				tagName: 'li',
				className: 'menu-item',
				templateName: opts.childViewTemplate,
			},
			...opts.childView,
		};
		opts.template = opts.template || Template;
		super(opts);

		this.childViewTemplate = opts.childViewTemplate;
	}

	/** @override */
	doTemplate() {
		return this.template({
			...this.collection,
			items: this.collection.models,
		});
	}

	/** @type {string} */
	static get __name__() {
		return 'AdvancedMenuView';
	}
}

// Functionality

ChildViews(AdvancedMenuView);
